/* eslint-disable camelcase */
/* eslint-disable no-unused-expressions */
import React, { useEffect, useState, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import './style.scss';
import {
  Table, Checkbox, Alert,
} from 'antd';
import WhatsappIntegrationActions from '@Actions/integrations/whatsappIntegrationActions';
import UserActions from '@Actions/userActions';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';

/**
 *
 */
const WhatsappConfiguration = ({
  user, updateWhatsappConfiguration, getWhatsappConnections, getWhatsappConnectionsLoading, updateWhatsappConfigurationLoading, getUserProfile,
}) => {
  const [data, setData] = useState([]);

  const keyMap = {
    po: 'is_po_notification_enabled',
    se: 'is_se_notification_enabled',
    so: 'is_so_notification_enabled',
    inv: 'is_inv_notification_enabled',
    poa: 'is_purchase_order_approval_enabled',
    sta: 'is_stock_transfer_approval_enabled',
    pra: 'is_purchase_requisition_approval_enabled',
    soa: 'is_sales_order_approval_enabled',
    amca: 'is_amc_notification_enabled',
    inva: 'is_invoice_approval_enabled',
    grn: 'is_grn_notification_enabled',
    saa: 'is_stock_adjustment_approval_enabled',
    poaa: 'is_payment_outgoing_approval_enabled',
    poAuto: 'is_po_automatic_notification_enabled',
    soAuto: 'is_so_automatic_notification_enabled',
    invAuto: 'is_inv_automatic_notification_enabled',
  };

  useEffect(() => {
    getWhatsappConnections(user?.tenant_info?.org_id, (connections) => {
      const tenantIntegration = connections?.tenant_integrations?.find((tenant) => tenant?.tenant_id === user?.tenant_info?.tenant_id);
      if (tenantIntegration) {
        const mainData = [
          {
            entity: 'po',
            entityName: 'Purchase Order',
            is_po_notification_enabled: tenantIntegration?.is_po_notification_enabled,
            is_po_automatic_notification_enabled: tenantIntegration?.is_po_automatic_notification_enabled,
          },
          {
            entity: 'se',
            entityName: 'Estimate',
            is_se_notification_enabled: tenantIntegration?.is_se_notification_enabled,
            is_se_automatic_notification_enabled: tenantIntegration?.is_se_automatic_notification_enabled,
          },
          {
            entity: 'so',
            entityName: 'Sales Order',
            is_so_notification_enabled: tenantIntegration?.is_so_notification_enabled,
            is_so_automatic_notification_enabled: tenantIntegration?.is_so_automatic_notification_enabled,
          },
          {
            entity: 'amc',
            entityName: 'AMC Sales Order',
            is_amc_notification_enabled: tenantIntegration?.is_amc_notification_enabled,
            is_amc_automatic_notification_enabled: tenantIntegration?.is_amc_automatic_notification_enabled,
          },
          {
            entity: 'inv',
            entityName: 'Invoice',
            is_inv_notification_enabled: tenantIntegration?.is_inv_notification_enabled,
            is_inv_automatic_notification_enabled: tenantIntegration?.is_inv_automatic_notification_enabled,
          },
          {
            entity: 'poa',
            entityName: 'Purchase Order Approval',
            is_purchase_order_approval_enabled: tenantIntegration?.is_purchase_order_approval_enabled,
          },
          {
            entity: 'soa',
            entityName: 'Sales Order Approval',
            is_sales_order_approval_enabled: tenantIntegration?.is_sales_order_approval_enabled,
          },
          {
            entity: 'inva',
            entityName: 'Invoice Approval',
            is_invoice_approval_enabled: tenantIntegration?.is_invoice_approval_enabled,
          },
          {
            entity: 'sta',
            entityName: 'Stock Transfer Approval',
            is_stock_transfer_approval_enabled: tenantIntegration?.is_stock_transfer_approval_enabled,
          },
          {
            entity: 'saa',
            entityName: 'Stock Adjustment Approval',
            is_stock_adjustment_approval_enabled: tenantIntegration?.is_stock_adjustment_approval_enabled,
          },
          {
            entity: 'pra',
            entityName: 'Material request Approval',
            is_purchase_requisition_approval_enabled: tenantIntegration?.is_purchase_requisition_approval_enabled,
          },
          {
            entity: 'grn',
            entityName: 'Good Receiving Note Approval',
            is_grn_notification_enabled: tenantIntegration?.is_grn_notification_enabled,
          },
          {
            entity: 'poaa',
            entityName: 'Payment Outgoing Approval',
            is_payment_outgoing_approval_enabled: tenantIntegration?.is_payment_outgoing_approval_enabled,
          },
        ];

        setData(mainData);
      }
    });
  }, []);

  const checkDisabled = (record) => {
    if (record?.entity === 'po') {
      return record?.is_po_notification_enabled;
    }
    if (record?.entity === 'se') {
      return record?.is_se_notification_enabled;
    }
    if (record?.entity === 'so') {
      return record?.is_so_notification_enabled;
    }
    if (record?.entity === 'amc') {
      return record?.is_amc_notification_enabled;
    }
    if (record?.entity === 'inv') {
      return record?.is_inv_notification_enabled;
    }
    if (record?.entity === 'grn') {
      return record?.is_grn_notification_enabled;
    }
  };

  const handleCheckboxChange = (record, key1, key2, value) => {
    const copyData = JSON.parse(JSON.stringify(data));
    const updatedData = copyData.map((obj) => {
      if (obj.entity === record.entity) {
        return { ...obj, [key1]: value, [key2]: value };
      }
      return obj;
    });
    setData(updatedData);
  };

  const columns = [
    {
      title: 'NOTIFICATION TYPE',
      render: (record) => record?.entityName,
    },
    {
      title: 'ENABLED',
      render: (record) => {
        let enabled = true;
        if (record?.entity === 'po') {
          enabled = record?.is_po_notification_enabled;
        }
        if (record?.entity === 'se') {
          enabled = record?.is_se_notification_enabled;
        }
        if (record?.entity === 'so') {
          enabled = record?.is_so_notification_enabled;
        }
        if (record?.entity === 'inv') {
          enabled = record?.is_inv_notification_enabled;
        }
        if (record?.entity === 'poa') {
          enabled = record?.is_purchase_order_approval_enabled;
        }
        if (record?.entity === 'soa') {
          enabled = record?.is_sales_order_approval_enabled;
        }
        if (record?.entity === 'amca') {
          enabled = record?.is_amc_sales_order_approval_enabled;
        }
        if (record?.entity === 'inva') {
          enabled = record?.is_invoice_approval_enabled;
        }
        if (record?.entity === 'grn') {
          enabled = record?.is_grn_notification_enabled;
        }
        if (record?.entity === 'sta') {
          enabled = record?.is_stock_transfer_approval_enabled;
        }
        if (record?.entity === 'saa') {
          enabled = record?.is_stock_adjustment_approval_enabled;
        }
        if (record?.entity === 'pra') {
          enabled = record?.is_purchase_requisition_approval_enabled;
        }
        if (record?.entity === 'poaa') {
          enabled = record?.is_payment_outgoing_approval_enabled;
        }
        return (
          <div>
            <Checkbox
              checked={enabled}
              onChange={(event) => {
                const key1 = keyMap[record.entity];
                let key2;
                if (record.entity === 'po') {
                  key2 = keyMap.poAuto;
                }
                if (record.entity === 'so') {
                  key2 = keyMap.soAuto;
                }
                if (record.entity === 'inv') {
                  key2 = keyMap.invAuto;
                }
                handleCheckboxChange(record, key1, key2, event.target.checked);
              }}
            />
          </div>
        );
      },
    },
    {
      title: 'SEND AUTOMATIC NOTIFCATION',
      render: (record) => {
        let enabled = true;
        if (record?.entity === 'po') {
          enabled = record?.is_po_automatic_notification_enabled;
        }
        if (record?.entity === 'so') {
          enabled = record?.is_so_automatic_notification_enabled;
        }
        if (record?.entity === 'inv') {
          enabled = record?.is_inv_automatic_notification_enabled;
        }
        return (['po', 'so', 'inv'].includes(record?.entity) && (
          <div>
            <Checkbox
              checked={enabled}
              onChange={(event) => {
                let key2;
                if (record.entity === 'po') {
                  key2 = keyMap.poAuto;
                }
                if (record.entity === 'so') {
                  key2 = keyMap.soAuto;
                }
                if (record.entity === 'inv') {
                  key2 = keyMap.invAuto;
                }
                handleCheckboxChange(record, null, key2, event.target.checked);
              }}
              disabled={!checkDisabled(record)}
            />
          </div>
        ));
      },
    },
  ];

  const handleSubmit = () => {
    const configuration = data.reduce((result, item) => {
      const { entity, entityName, ...rest } = item;
      Object.assign(result, rest);
      return result;
    }, {});

    const payload = [
      {
        org_id: user?.tenant_info?.org_id,
        tenant_id: user?.tenant_info?.tenant_id,
        ...configuration,
      },
    ];

    updateWhatsappConfiguration(payload, () => {
      getUserProfile();
    });
  };

  return (
    <Fragment>
      {(getWhatsappConnectionsLoading)
        ? (
          <div className="whatsapp-bp-integration__loader__wrapper">

            {[...Array(5).keys()].map((item) => (
              <div key={item} className="whatsapp-bp-integration__loader-row">
                <div className="loadingBlock  whatsapp-bp-integration__loader__line1" />
                <div className="loadingBlock  whatsapp-bp-integration__loader__line2" />
                <div className="loadingBlock  whatsapp-bp-integration__loader__line3" />
              </div>
            ))}
            {[...Array(5).keys()].map((item) => (
              <div key={item} className="whatsapp-bp-integration__loader-row">
                <div className="loadingBlock  whatsapp-bp-integration__loader__line1" />
                <div className="loadingBlock  whatsapp-bp-integration__loader__line2" />
                <div className="loadingBlock  whatsapp-bp-integration__loader__line3" />
              </div>
            ))}
            <div className="loadingBlock whatsapp-bp-integration__loader__line-btn1" />
            <div className="loadingBlock whatsapp-bp-integration__loader__line-btn2" />
          </div>
        )
        : (
          <div className="whatsapp__tenant-config">

            <div className="whatsapp__tenant-config-table-wrapper">
              <div className="ant-row">
                <div className="ant-col-md-18 show-table-header-in-mobile width-100-in-mobile">
                  <Table
                    columns={columns}
                    dataSource={data}
                    pagination={false}
                    size="small"
                  />
                </div>
                <div className="ant-col-md-18" />
                <div className="ant-col-md-18" style={{ marginTop: '15px' }}>
                  <Alert
                    showIcon
                    message={(
                      <div>
                        Automatic notifications are only triggered when the document status is ISSUED or CONFIRMED.
                      </div>
                    )}
                    type="info"
                    style={{ borderRadius: '4px' }}
                  />
                </div>
              </div>
            </div>

            <div className="whatsapp-config__tenant-config-footer-wrapper">
              <H3Button
                text="Save"
                buttonType={defaultButtonTypes.BLUE_ROUNDED}
                onClick={() => handleSubmit()}
                customClass="whatsapp-config__account-submit"
                isLoading={updateWhatsappConfigurationLoading}
                disabled={updateWhatsappConfigurationLoading}
              />
            </div>
          </div>
        )}
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers, WhatsappIntegrationReducers }) => ({
  user: UserReducers.user,
  getWhatsappConnectionsLoading: WhatsappIntegrationReducers.getWhatsappConnectionsLoading,
  updateWhatsappConfigurationLoading: WhatsappIntegrationReducers.updateWhatsappConfigurationLoading,
});

const mapDispatchToProps = (dispatch) => ({
  updateWhatsappConfiguration: (payload, callback) => dispatch(WhatsappIntegrationActions.updateWhatsappConfiguration(payload, callback)),
  getWhatsappConnections: (orgId, callback) => dispatch(WhatsappIntegrationActions.getWhatsappConnections(orgId, callback)),
  getUserProfile: (callback) => dispatch(UserActions.getUserProfile(callback)),
});

WhatsappConfiguration.propTypes = {
  user: PropTypes.any,
  updateWhatsappConfiguration: PropTypes.func,
  getWhatsappConnections: PropTypes.func,
  getWhatsappConnectionsLoading: PropTypes.bool,
  updateWhatsappConfigurationLoading: PropTypes.bool,
  getUserProfile: PropTypes.func,
  isPoNotificationActive: PropTypes.any,
  onCheckboxClick: PropTypes.any,
  isActive: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(WhatsappConfiguration));
